import type { CatalogueEntry } from "../types";
import imageLight from "../images/building-first-floor-elevation.light.webp";
import imageDark from "../images/building-first-floor-elevation.dark.webp";

export const entry: CatalogueEntry = {
  slug: "building-first-floor-elevation",
  displayName: `Building First Floor Elevation`,
  datasetProductCode: `BUILDING-FIRST-FLOOR-ELEVATION`,
  subtitle: `First Floor Elevation, Basement and Entrance Insights for Buildings`,
  shortDescription: `The Building First Floor Elevation (FFE) Insight Pack provides building-level information on how a building sits relative to the ground, including the elevation of the lowest habitable floor and indicators for basements, garages and raised entrances.
Derived from street-level imagery and Geoscape data, FFE links 1:1 to a building in the National Buildings product through the building_pid, supporting flood modelling, risk assessment and property analysis.`,
  metadata: {
    dateAdded: 1787270400000,
    dataType: ["Aspatial"],
    theme: `Built Environment`,
    totalFeatureCount: 0,
    updateFrequency: `As Deemed Necessary`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  comingSoon: true,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/geoscape-australia-docs-building-ffe2-insight-pack/en/stable/`,
  imageLight,
  imageDark,
  searchTags: `Building First Floor Elevation FFE National Buildings Insight Pack Habitable Floor Basement Garage Raised Entrance Flood Risk Flood Modelling Insurance Property Analysis Street Level Imagery Geoscape Buildings Elevation`,
  detail: () =>
    import("../details/building-first-floor-elevation").then((m) => m.detail),
};

export default entry;
